@if (profile) {
  <!-- Greeting + Clock -->
  <div class="flex items-center justify-between px-4 pb-0 pt-4">
    <div class="text-lg font-bold tracking-tight text-gray-900">
      {{ greeting }}, <span class="text-primary">{{ profile?.first_name }}</span>
    </div>
    <app-digital-clock class="hidden sm:block"></app-digital-clock>
  </div>

  <!-- Dashboard Switcher — visible only when user has access to multiple role dashboards -->
  @if (availableDashboards.length > 1) {
    <!-- Mobile: single button + mat-menu dropdown -->
    <div class="flex items-center px-4 pb-0 pt-3 md:hidden">
      <span class="text-secondary mr-2 text-xs font-semibold uppercase tracking-wide">View:</span>
      <button mat-stroked-button [matMenuTriggerFor]="mobileMenu" class="flex !h-8 !min-w-0 items-center gap-1 !border-primary !bg-primary-50 !px-3 !text-xs !text-primary">
        <mat-icon class="!h-4 !w-4 !text-sm !leading-none">{{ currentDashboardIcon }}</mat-icon>
        <span>{{ currentDashboardLabel }}</span>
        <mat-icon class="ml-1 !h-4 !w-4 !text-sm !leading-none">arrow_drop_down</mat-icon>
      </button>
      <mat-menu #mobileMenu="matMenu">
        @for (d of availableDashboards; track d.type) {
          <button mat-menu-item (click)="switchDashboard(d.type)" [class.font-semibold]="dashboardSvc.dashboardView() === d.type">
            <mat-icon>{{ d.icon }}</mat-icon>
            <span>{{ d.label }}</span>
          </button>
        }
      </mat-menu>
    </div>

    <!-- Desktop: compact pill tabs -->
    <div class="hidden items-center overflow-x-auto px-4 pb-1 pt-2 md:flex">
      @for (d of availableDashboards; track d.type) {
        @if (d.type !== 'map') {
          <button
            class="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-sm font-medium transition-colors"
            [ngClass]="dashboardSvc.dashboardView() === d.type ? 'bg-primary-50 text-primary' : 'text-gray-900 hover:bg-gray-200'"
            (click)="switchDashboard(d.type)"
          >
            <mat-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">{{ d.icon }}</mat-icon>
            {{ d.label }}
          </button>
        }
      }

      <!-- Map — icon-only pill with separator -->
      @if (hasMapTab) {
        <span class="mx-1.5 h-4 w-px shrink-0 bg-gray-200"></span>
        <button
          class="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-sm font-medium transition-colors"
          [ngClass]="dashboardSvc.dashboardView() === 'map' ? 'bg-primary-50 text-primary' : 'text-gray-900 hover:bg-gray-200'"
          (click)="switchDashboard('map')"
          matTooltip="Map View"
        >
          <mat-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">map</mat-icon>
        </button>
      }
    </div>
  }

  @if (dashboardSvc.dashboardView() === 'executive') {
    <app-executive-dashboard></app-executive-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'finance') {
    <app-finance-dashboard></app-finance-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'facilities') {
    <app-facilities-dashboard></app-facilities-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'procurement') {
    <app-procurement-dashboard></app-procurement-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'regulatory') {
    <app-regulatory-dashboard></app-regulatory-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'support') {
    <app-support-dashboard></app-support-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'sysadmin') {
    <app-sysadmin-dashboard></app-sysadmin-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'staff') {
    <app-staff-dashboard></app-staff-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'map') {
    <app-map-dashboard class="w-full"></app-map-dashboard>
  }
  @if (dashboardSvc.dashboardView() === 'personal') {
    <app-my-dashboard class="w-full"></app-my-dashboard>
  }
}
